import { createContext, ReactNode, useContext, useEffect, useState } from 'react'
import { useAuth } from 'react-oidc-context'

type UserProps = {
  name?: string
  roles: string[]
  token: string
  orgaoExterno?: number[]
  foto?: string
}

type AuthContextProps = {
  user: UserProps | null
  isLoading: boolean
}

type PayloadAttributes = {
  iss: string
  name: string
  resource_access: {
    mac?: {
      roles?: string[]
    }
  }
  orgaoExterno?: number[]
  foto?: string
}

const AuthContext = createContext<AuthContextProps>({} as AuthContextProps)

const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<UserProps>()
  const [isLoading, setLoading] = useState<boolean>(true)

  const { user: userAuth } = useAuth()

  useEffect(() => {
    const decodeToken = async () => {
      try {
        if (userAuth && userAuth.access_token) {
          const payload = JSON.parse(atob(userAuth.access_token.split('.')[1])) as PayloadAttributes

          setUser({
            name: payload.name,
            token: userAuth.access_token,
            roles: payload.resource_access?.mac?.roles || [],
            foto: payload.foto,
          })
          setLoading(false)
        }
      } catch (error) {
        console.error('Error decoding JWT token:', error)
        setLoading(false)
      }
    }

    decodeToken()
  }, [userAuth])

  return (
    <AuthContext.Provider value={{ user: user, isLoading } as AuthContextProps}>
      <>{children}</>
    </AuthContext.Provider>
  )
}

const useAuthContext = () => {
  const { user, isLoading } = useContext(AuthContext)

  const handleHasPermission = (permission: string): boolean => {
    if (user) {
      return user.roles.includes(permission)
    }
    return false
  }

  const hasOrgaoExterno = (orgaoExterno: number) => {
    return true
  }

  return { user, handleHasPermission, hasOrgaoExterno, isLoading }
}

export { AuthProvider, AuthContext, useAuthContext }
